var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"FooterComp":""}},[_c('div',{staticClass:"d-flex justify-content-center footer-content"},[_c('span',[_vm._v("Powered by Panasonic")])])])
}]

export { render, staticRenderFns }